export const getBrowserLocale = function() {
	return window.navigator.language;
};
